module.exports = __webpack_public_path__ + "img/dollar-sign.45b98285.svg";